module.exports = __webpack_public_path__ + "img/744.e56631b9.jpg";